module.exports = __webpack_public_path__ + "img/wordpress-logo.3eba492d.webp";